// extracted by mini-css-extract-plugin
export default {"imageWrapper":"eN-z","twoColumnImage":"fN-z"};